import React from "react"
import { NextSeo } from "next-seo"

import Layout from "~/components/Pages/Basic"
import Center from "~/components/basic/Center"

import Categories from "~/components/faq/Categories"
import Spacer from "~/components/Spacer"

const FAQCategoryPage = () => {
  return (
    <>
      <NextSeo
        title="FAQ | WinIt"
        description="Get answers to common questions about WinIt, parking ticket disputes, traffic ticket management, and more."
        canonical="https://www.appwinit.com/faq"
        additionalMetaTags={[
          {
            property: "description",
            content:
              "Get answers to common questions about WinIt, parking ticket disputes, traffic ticket management, and more.",
          },
        ]}
      />
      <Layout>
        <Center>
          <h1>Frequently Asked Questions</h1>
          <p>All the answers to your questions about WinIt and tickets.</p>
          <p>Pick a category to get started.</p>
        </Center>
        <Categories />
        <Spacer mobile={30} desktop={30} />
      </Layout>
    </>
  )
}

export default FAQCategoryPage
